import {clickEvent} from "../../../webpack/modules/events";

clickEvent('header .open-left-menu', false, function() {
    import(/* webpackChunkName: "header-left-menu-v2" */ '../../LeftMenuV2/main');
});